import { makeStyles } from "@material-ui/core"

export const cancelLoadStyle = makeStyles((theme) => ({
    commentReminder: {
        padding: '0.5em 1em',
        background: '#d5edff',
        marginBottom: '0.5em',
        borderRadius: '3px',
    }
}));